/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum VboExpandParams {
    Vb365Server = 'Vb365Server',
    OrganizationDetails = 'OrganizationDetails',
}
